
import { DestroyRef, Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AppState } from '../store/app.state';
import { UserSelectors } from '@states/user/user.selector-types';
import { AppUser } from '../user/user.model';
import User = AppUser.User;
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[ifMagentrix]',
  standalone: true,
})
export class IfMagentrixDirective {
  public selectUser$: Observable<User> = this.store$.pipe(select(UserSelectors.selectUser));
  private isMagentrix = false;
  constructor(
    private templateRef: TemplateRef<any>, 
    private viewContainer: ViewContainerRef, 
    private store$: Store<AppState>,
    private destroyRef: DestroyRef,
  ) {
    this.selectUser$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res => {
        this.isMagentrix = res?.roles?.some(role=>role.indexOf('magentrix')>-1) ?? false;
        this.showIfUserAuthorized();
      });
  }

  async showIfUserAuthorized() {
    this.viewContainer.clear();
    if (this.isMagentrix) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
